import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PayBillService {
  accountID: any;
  policyCheckDigits: any;
  xmlResp: any;

  setVal(accountID, policyCheckDigits, xmlResp) {
    this.accountID = accountID;
    this.policyCheckDigits = policyCheckDigits;
    this.xmlResp = xmlResp;
  }
}
